module.exports = __webpack_public_path__ + "img/movieTheater-1.0f6ad658.jpg";